import styled from "styled-components";
import { media } from "@/styles/media";
import { theme } from "@/styles/theme";
import { IFontProps } from "@/typings/Props";

type TOwnProps = {
  $bg?: string;
  $fontSize?: string;
  $contentWidth?: string;
};

export default function Banner({ ...props }) {
  return (
    <BannerWrapper $bg={props.Bg}>
      {Boolean(!props.isResultSheet) && <BannerOverlay />}
      <TextWrapper>
        <Area>
          <P
            $fontSize="2rem"
            $fontWeight={theme.fontWeights.bold}
            $contentWidth={props.$contentWidth ? props.$contentWidth : "520px"}
            data-aos="fade-up"
            data-aos-easing="ease-out"
            data-aos-delay="100"
            data-aos-duration="600"
          >
            {props.Headline}
          </P>
          <P
            id="title"
            $fontSize={props.$fontSize ? props.$fontSize : "5rem"}
            $fontWeight={theme.fontWeights.bold}
            $contentWidth={props.$contentWidth ? props.$contentWidth : "520px"}
            data-aos="fade-up"
            data-aos-easing="ease-out"
            data-aos-delay="200"
            data-aos-duration="600"
          >
            {props.Title}
          </P>
          <P
            id="desc"
            $lineHeight="150%"
            $contentWidth={props.$contentWidth ? props.$contentWidth : "520px"}
            data-aos="fade-up"
            data-aos-easing="ease-out"
            data-aos-delay="300"
            data-aos-duration="600"
          >
            {props.Desc}
          </P>
        </Area>
      </TextWrapper>
    </BannerWrapper>
  );
}

const BannerWrapper = styled.div<TOwnProps>`
  position: relative;
  width: 100%;
  height: 520px;
  background-color: ${theme.colors.primary};
  background-image: url(${(props) => props.$bg});
  background-size: cover;
  background-position-y: 55%;
  ${media.tablet`
    height: 708px;
    background-position: 50%;
  `}
`;
const BannerOverlay = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(1, 1, 1, 0.5);
  mix-blend-mode: multiply;
`;
const TextWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1245px;
  height: auto;
  display: flex;
  ${media.desktopMid`
    margin: auto;
    width: 100%;
    padding: 0 80px;
    `}
`;
const Area = styled.div`
  width: 50%;
  height: auto;
  ${media.phablet`
    width: 100%;
  `}
`;

const P = styled.p<IFontProps & TOwnProps>`
  font-size: ${(props) => props.$fontSize};
  font-weight: ${(props) => props.$fontWeight};
  line-height: ${(props) => (props.$lineHeight ? props.$lineHeight : "")};
  margin-bottom: 15px;
  color: ${theme.colors.text.white};
  white-space: pre-line;
  &#desc {
    width: ${(props) => props.$contentWidth};
  }
  &#title {
    width: ${(props) => props.$contentWidth};
  }

  ${media.tablet`
    &#desc {
      width: 100%;
    }
    &#title {
      width: 100%;
      font-size: 2.5rem;
    }
  `}
  ${media.phablet`
    text-align: center;
  `}
`;
